import { put, call, all, takeEvery } from 'redux-saga/effects';
import { planFeaturesActionTypes } from './PlanFeatures.actionTypes';
import { getPlanFeaturesAndModules } from '@/services/planFeatures';

export function* getPlanFeaturesAndModulesSaga() {
  try {
    yield put({
      type: planFeaturesActionTypes.SET_STATE,
      payload: { loading: true },
    });
    const data = yield call(getPlanFeaturesAndModules);
    if (data) {
      const { allModulesAndFeatures, ...plans } = data;
      yield put({
        type: planFeaturesActionTypes.SET_ALL_FEATURES_AND_MODULES,
        payload: allModulesAndFeatures,
      });
      yield put({ type: planFeaturesActionTypes.SET_PLANS, payload: plans });
    }
  } catch (error) {
    yield put({
      type: planFeaturesActionTypes.SET_STATE,
      payload: { error: error.message },
    });
  } finally {
    yield put({
      type: planFeaturesActionTypes.SET_STATE,
      payload: { loading: false },
    });
  }
}

export default function* planFeaturesWatcher() {
  yield all([
    takeEvery(
      planFeaturesActionTypes.GET_FEATURES_AND_MODULES,
      getPlanFeaturesAndModulesSaga
    ),
  ]);
}
